import React, { useState } from 'react'
import logo from "../images/logo.png";
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { server_API } from '../config'
import login from '../images/login.png'
import { TailSpin } from "react-loader-spinner"
import axiosInstance from '../axiosInstance'
import { toast, ToastContainer } from 'react-toastify';
// 4. Remove "Total" from total applications recieved

const ForgotPassword = () => {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [checked, setChecked] = useState(false)
  const [otp1, setOtp1] = useState('')
  const [otp2, setOtp2] = useState('')
  const [otp3, setOtp3] = useState('')
  const [otp4, setOtp4] = useState('')
  const [otp5, setOtp5] = useState('')
  const [otp6, setOtp6] = useState('')
  const [invalid, setInvalid] = useState(false)
  const [otpsent, setOTPSent] = useState(false)
  const [counter, setCounter] = useState(30)
  const [verify, setVerify] = useState(false)
  const [loader, setLoader] = useState(false)


  React.useEffect(() => {
    if (otpsent == true) {
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, otpsent]);



  const sendOTP = () => {
    if (email.length > 0) {
      setOTPSent(true)
      axiosInstance.post(`/v2/user/genOtp/${email}`)
        .then((res) => {
          setOTPSent(true)
          setLoader(false)
          toast.success(`OTP has been sent to ${email}`, { position: "top-center", className: "dark-mode-toast" })
        })
        .catch((err) => {
          console.log(err)
          alert('Could not send OTP, please trye again')
        })
    } else {
      toast.error("Please enter the email before sending the OTP", { position: "top-center", className: "dark-mode-toast" })
    }

  }

  const verifyOTP = (parsedOtp) => {

    // axios.get(`${server_API}/v1/email/verify/${email}/${otp1+otp2+otp3+otp4+otp5+otp6}`)
    // .then((res)=>{
    //   navigate('/app/resetPassword',{state:{id:res.data.sucess}})
    //   console.log(res)
    // })
    // .catch((err)=>{
    //   console.log(err)
    // })


    axiosInstance.post(`/v2/user/login`, {
      email: email,
      password: password,
      otp: parsedOtp
    })
      .then((res) => {
        navigate('/resetPassword', { state: { id: res.data.success } })
        // if(res.data.ATSEnabled){
        //   window.location.href="http://localhost:3000/ats/#/home"
        // }
        // else{
        //   window.location.href="https://test.northstarz.ai/app/#/home"
        // }
      })
      .catch((err) => {
        console.log(err)
      })
  }


  const nav = () => {
    axios.post(`${server_API}/v1/user/login`, {
      email: email,
      password: password
    })
      .then((response) => {
        console.log(response)
        // localStorage.setItem('uuid',response.data.success)
        // dispatch(updateUserId(response.data.success))
        axios.patch(`${server_API}/v1/user/update`, {
          uuid: response.data.success,
          status: "accepted"
        })
          .then((response) => {
            console.log(response)
            navigate('/app/home')
          })
          .catch((error) => {
            console.log(error)
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }
  return (
    <div className="bg-cover min-h-screen p-5 bgGradient" >
      <div className="p-2">
        <img src={logo} className="h-10 mb-10"></img>
      </div>
      <div className="my-6">
        <div className="">
          <div className="w-1/2 bg-white py-5 px-10 rounded-xl shadow-2xl mx-auto my-4">
            <div className="grid grid-cols-2">
              <div className="flex flex-col space-y-8 justify-center">
                <p className="text-center font-semibold text-lg">Forgot Password</p>
                <div >
                  <p className="font-semibold mb-2">Email</p>
                  <input value={email} onChange={(e) => { setEmail(e.target.value) }} type="email" className="w-full outline-none border-2 rounded-md px-2 py-1" placeholder="Enter your registered email"></input>
                </div>
                <div>
                  {
                    otpsent &&
                    <div>
                      <div className="  text-left my-6  w-full  space-y-3  mb-4 ">
                        <div className="flex  items-start mx-auto justify-center w-full  space-x-4 ">
                          <input type="text" name="field-1" className={invalid ? "border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center" : "border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp1} onChange={(e) => {
                            const { maxLength, value, name } = e.target
                            const [fieldName, fieldIndex] = name.split("-");
                            let fieldIntIndex = parseInt(fieldIndex, 10);
                            if (value.length >= maxLength) {

                              // It should not be last input field
                              if (fieldIntIndex < 6) {

                                // Get the next input field using it's name
                                const nextfield = document.querySelector(
                                  `input[name=field-${fieldIntIndex + 1}]`
                                );

                                // If found, focus the next field
                                if (nextfield !== null) {
                                  nextfield.focus();
                                }
                              }
                            }
                            setOtp1(e.target.value)
                          }}></input>
                          <input type="text" name="field-2" className={invalid ? "border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center" : "border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp2} onChange={(e) => {
                            const { maxLength, value, name } = e.target
                            const [fieldName, fieldIndex] = name.split("-");
                            let fieldIntIndex = parseInt(fieldIndex, 10);
                            if (value.length >= maxLength) {

                              // It should not be last input field
                              if (fieldIntIndex < 6) {

                                // Get the next input field using it's name
                                const nextfield = document.querySelector(
                                  `input[name=field-${fieldIntIndex + 1}]`
                                );

                                // If found, focus the next field
                                if (nextfield !== null) {
                                  nextfield.focus();
                                }
                              }
                            }
                            setOtp2(e.target.value)
                          }}></input>
                          <input type="text" name="field-3" className={invalid ? "border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center" : "border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp3} onChange={(e) => {
                            const { maxLength, value, name } = e.target
                            const [fieldName, fieldIndex] = name.split("-");
                            let fieldIntIndex = parseInt(fieldIndex, 10);
                            if (value.length >= maxLength) {

                              // It should not be last input field
                              if (fieldIntIndex < 6) {

                                // Get the next input field using it's name
                                const nextfield = document.querySelector(
                                  `input[name=field-${fieldIntIndex + 1}]`
                                );

                                // If found, focus the next field
                                if (nextfield !== null) {
                                  nextfield.focus();
                                }
                              }
                            }
                            setOtp3(e.target.value)
                          }}></input>
                          <input type="text" name="field-4" className={invalid ? "border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center" : "border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp4} onChange={(e) => {
                            const { maxLength, value, name } = e.target
                            const [fieldName, fieldIndex] = name.split("-");
                            let fieldIntIndex = parseInt(fieldIndex, 10);
                            if (value.length >= maxLength) {

                              // It should not be last input field
                              if (fieldIntIndex < 6) {

                                // Get the next input field using it's name
                                const nextfield = document.querySelector(
                                  `input[name=field-${fieldIntIndex + 1}]`
                                );

                                // If found, focus the next field
                                if (nextfield !== null) {
                                  nextfield.focus();
                                }
                              }
                            }
                            setOtp4(e.target.value)
                          }}></input>
                          <input type="text" name="field-5" className={invalid ? "border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center" : "border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp5} onChange={(e) => {
                            const { maxLength, value, name } = e.target
                            const [fieldName, fieldIndex] = name.split("-");
                            let fieldIntIndex = parseInt(fieldIndex, 10);
                            if (value.length >= maxLength) {

                              // It should not be last input field
                              if (fieldIntIndex < 6) {

                                // Get the next input field using it's name
                                const nextfield = document.querySelector(
                                  `input[name=field-${fieldIntIndex + 1}]`
                                );

                                // If found, focus the next field
                                if (nextfield !== null) {
                                  nextfield.focus();
                                }
                              }
                            }
                            setOtp5(e.target.value)
                          }}></input>
                          <input type="text" name="field-6" className={invalid ? "border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center" : "border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp6} onChange={(e) => {
                            const { maxLength, value, name } = e.target
                            const [fieldName, fieldIndex] = name.split("-");
                            let fieldIntIndex = parseInt(fieldIndex, 10);
                            if (value.length >= maxLength) {

                              // It should not be last input field
                              if (fieldIntIndex < 6) {

                                // Get the next input field using it's name
                                const nextfield = document.querySelector(
                                  `input[name=field-${fieldIntIndex + 1}]`
                                );

                                // If found, focus the next field
                                if (nextfield !== null) {
                                  nextfield.focus();
                                }
                              }
                            }
                            setOtp6(e.target.value)
                          }}></input>
                        </div>
                        <div className="flex items-center space-x-3 justify-center">
                          <div className=" text-center ">
                            {
                              invalid &&
                              <p className="font-poppins text-sm my-3 lg:hidden block text-red-500">Invalid OTP</p>
                            }
                            <button className="px-10 text-sm  bg-blue-500 text-white  rounded-xl py-2  " onClick={() => {
                              verifyOTP()
                            }}>Verify</button>
                          </div>
                          <div className="text-center">
                            <button disabled={counter > 0} className="px-10  text-sm bg-blue-500 text-white rounded-xl py-2  " onClick={() => {
                              setCounter(30)
                              sendOTP()
                            }}>
                              {
                                counter > 0 ?
                                  counter
                                  :
                                  "Resend"
                              }
                            </button>
                          </div>
                        </div>
                      </div>
                      {
                        invalid &&
                        <p className="font-poppins text-sm my-3 hidden lg:block text-red-500">Invalid OTP</p>
                      }
                      <p className='text-center text-sm font-poppins my-3'>A six digit OTP has been sent to your email id.</p>
                    </div>
                  }

                </div>


                <div >
                  {
                    !otpsent &&
                    <button disabled={(!(email) && (email.includes('@'))) || loader} onClick={() => { sendOTP() }} className={((email && email.includes('@'))) ? "bg-[#148EFF] text-white w-full rounded-xl py-3" : "bg-gray-400 text-white w-full rounded-xl py-3"}>
                      {
                        loader ?
                          <div className="flex w-full justify-center">
                            <TailSpin className="text-center mx-auto" color="white" height="30" width="30"></TailSpin>
                          </div>
                          :
                          'Send OTP'
                      }
                    </button>
                  }
                </div>
              </div>
              <div>
                <img src={login}></img>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default ForgotPassword